import { Component, Injector, Input } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { StringUtils } from '@shared/helpers/StringUtils';
import { EnderecoDto } from '@shared/service-proxies/service-proxies';
import { BuscaCepService } from '@shared/services/busca-cep.service';

@Component({
  selector: 'endereco-form',
  templateUrl: './form-endereco.component.html',
})
export class FormEnderecoComponent extends AppComponentBase {
  @Input() endereco: EnderecoDto = new EnderecoDto();
  public desabilitarCampoBairro: boolean = false;
  public desabilitarCampoEstado: boolean = false;
  public desabilitarCampoLogradouro: boolean = false;
  public desabilitarCampoCidade: boolean = false;

  constructor(injector: Injector, private _buscaCepService: BuscaCepService,) {
    super(injector)
  }

  protected onSelectCep($event) {
    this.habilitarCampos();
    this.endereco.cep = $event;

    if ($event.length == 8) {
      const sub = this._buscaCepService.getCep($event).subscribe(x => {
        if (x['erro']) {
          abp.message.error("CEP inválido");
        } else {
          this.endereco.logradouro = StringUtils.isNullOrEmpty(x['logradouro']) ? undefined : x['logradouro'];
          this.endereco.cidade = StringUtils.isNullOrEmpty(x['localidade']) ? undefined : x['localidade'];
          this.endereco.bairro = StringUtils.isNullOrEmpty(x['bairro']) ? undefined : x['bairro'];
          this.endereco.estado = StringUtils.isNullOrEmpty(x['uf']) ? undefined : x['uf'].toUpperCase();
          this.endereco.complemento = StringUtils.isNullOrEmpty(x['complemento']) ? undefined : x['complemento'];
          this.endereco.codigoIbge = StringUtils.isNullOrEmpty(x['ibge']) ? undefined : x['ibge'];
          this.endereco.numero = undefined;
          this.desabilitarCampoEstado = !StringUtils.isNullOrEmpty(this.endereco.estado);
          this.desabilitarCampoBairro = !StringUtils.isNullOrEmpty(this.endereco.bairro);
          this.desabilitarCampoLogradouro = !StringUtils.isNullOrEmpty(this.endereco.logradouro);
          this.desabilitarCampoCidade = !StringUtils.isNullOrEmpty(this.endereco.cidade);
        }
      });
    }
    else {
      this.endereco.logradouro = '';
      this.endereco.cidade = '';
      this.endereco.bairro = '';
      this.endereco.estado = '';
      this.endereco.complemento = '';
      this.endereco.numero = '';
      this.habilitarCampos
    }
  }

  public IsFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.endereco.cep), message: "Informe o cep do endereco." },
      { condition: StringUtils.isNullOrEmpty(this.endereco.logradouro), message: "Informe o logradouro do endereco." },
      { condition: StringUtils.isNullOrEmpty(this.endereco.bairro), message: "Informe o bairro do endereco." },
      { condition: StringUtils.isNullOrEmpty(this.endereco.cidade), message: "Informe o cidade do endereco." },
      { condition: StringUtils.isNullOrEmpty(this.endereco.estado), message: "Informe o estado do endereco." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  private habilitarCampos(): void {
    this.desabilitarCampoEstado = false;
    this.desabilitarCampoBairro = false;
    this.desabilitarCampoLogradouro = false;
    this.desabilitarCampoCidade = false;
  }
}
